
export enum CROSS_TOWN_ROUTES {
  START = 'crossTownInitial',
  FORM = 'crossTownNotes',
  SUMMARY = 'crossTownSummary',
  PAYMENT = 'crossTownPayment',
  FINISH = 'crossTownFinish',
}

export enum CLICK_AND_COLLECT_ROUTES {
  START = 'clickAndCollectInitial',
  FORM = 'clickAndCollectForm',
  SUMMARY = 'clickAndCollectSummary',
  FINISH = 'clickAndCollectFinish',
}

export enum CLICK_AND_COLLECT_CORTE_INGLES_ROUTES {
  START = 'CorteInglesInitial',
  EXPLANATION = 'CorteInglesExplanation',
  FORM = 'CorteInglesForm',
  SUMMARY = 'CorteInglesSummary',
  FINISH = 'CorteInglesFinish',
}

export enum AMAZON_RETURNS_ROUTES {
  START = 'amazonReturnsInitial',
  FORM = 'amazonReturnsForm',
  SUMMARY = 'amazonReturnsSummary',
  FINISH = 'amazonReturnsFinish',
}

export enum LOGIN_ROUTES {
  LOGIN = 'login',
  REGISTER = 'register',
  REGISTER_PHONE = 'register-phone',
  REGISTER_EMAIL = 'register-email',
  REGISTER_EMAIL_PHONE = 'register-email-phone',
  RESET = 'reset',
  VALIDATION = 'validation',
}

export enum HISTORY {
  START= 'historyInitial',
  SHIPMENT= 'historyShipment',
}

export enum OTHER_ROUTES {
  HOME = 'home',
  DEPOSIT_ITEM = "depositItem",
  PICKUP_ITEM = "pickUpItem",
  THANK_YOU = "thankYou",
  PROFILE = "profile",
}

export enum VIEW_OPTIONS {
  IS_REGISTER,
  IS_LOGIN,
  IS_SEND_RESET,
  IS_RESET,
  IS_VALIDATION,
}
